import { fetchCarHireOfferInsuranceQuote } from 'actions/CarHireActions'
import config from 'constants/config'
import GeoContext from 'contexts/geoContext'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useContext, useEffect } from 'react'

const EmptyState: App.CarHireOfferInsuranceQuoteInformationList = {
  data: undefined,
  fetching: false,
  error: undefined,
}

function useCarHireInsuranceQuote(params?: App.CarHireOfferInsuranceQuoteParams) {
  const dispatch = useAppDispatch()
  const { currentRegionCode } = useContext(GeoContext)
  const isCarHireInsuranceAvailableIncurrentRegion = config.CARHIRE_INSURANCE_REGIONS.split(',').includes(currentRegionCode)
  const isCarHireInsuranceAvailable = config.CARHIRE_INSURANCE_ENABLED
  const offerReferenceId = params?.reference.id || ''

  const insuranceQuoteInfo = useAppSelector(state => state.carHire.offerInsuranceQuoteLists[offerReferenceId] ?? EmptyState)

  useEffect(() => {
    if (params && isCarHireInsuranceAvailableIncurrentRegion && isCarHireInsuranceAvailable) {
      dispatch(fetchCarHireOfferInsuranceQuote(params))
    }
  }, [dispatch, isCarHireInsuranceAvailable, isCarHireInsuranceAvailableIncurrentRegion, params])

  return insuranceQuoteInfo
}

export default useCarHireInsuranceQuote
